import { FT_SINGLE } from '../FilterTypes';
import { CAT_ACTIVITY_SPHERES } from 'App/utils/Collections';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
};

export default {
  category: CAT_ACTIVITY_SPHERES,
  filters: [
    {
      id: 'id',
      label: 'ID Number',
      type: FT_SINGLE,
      group: groups.general,
      hint: '',
    },
  ],
  searchBarProp: 'translations.name',
};
